import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authService.getProfile()
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await authService.login({ email, password });
    localStorage.setItem('token', res.data.token);
    // For admin users, use the user data from login response directly
    // (admin may not have a profile, and phone.verified middleware would block getProfile for other routes)
    if (res.data.user?.role === 'admin') {
      setUser(res.data.user);
    } else {
      const profileRes = await authService.getProfile();
      setUser(profileRes.data);
    }
    return res.data;
  };

  const register = async (data) => {
    const res = await authService.register(data);
    localStorage.setItem('token', res.data.token);
    // Don't fetch full profile yet — user needs OTP verification first
    // Store minimal user info so we know they're logged in but unverified
    setUser({ ...res.data.user, phone_verified: false });
    return res.data;
  };

  const verifyOtp = async (otp) => {
    const res = await authService.verifyOtp(otp);
    // Refresh user profile after verification
    const profileRes = await authService.getProfile();
    setUser(profileRes.data);
    return res.data;
  };

  const resendOtp = async () => {
    const res = await authService.resendOtp();
    return res.data;
  };

  const logout = async () => {
    await authService.logout();
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, verifyOtp, resendOtp, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
